var _style, _circle, _path, _path2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#140F5A;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 500,
    x2: 1000,
    y2: 500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00D2"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 500,
    r: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.6,424.6c49.5-12.9,98.3-28.5,145.9-46.8c40.8-15.7,80.7-33.3,119.7-52.8L721.7,455.6 C667.2,448.6,613,438.3,559.6,424.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M789.1,472.8c-117.1-9.1-233.8-33.1-344.8-72.7c-95.9-34.2-187.7-80.1-273-135.1l219.3,313.7 C523.5,543.4,656.3,508.1,789.1,472.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "665.1,526.9 499.9,735 403.1,596.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd7d19641fbadc67987f32088986db5f.svg";
export { ForwardRef as ReactComponent };